export default () => ({
  categoriesList   : [],
  categoryDetailMap: {},
  totalCategories  : 0,
  selectedCategory : {},
});
